// @ts-nocheck
import { permissionsInitialApi as api } from './initialApi';
export const addTagTypes = ['permission-controller'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      updateUserGrants: build.mutation<
        UpdateUserGrantsApiResponse,
        UpdateUserGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/grants/${queryArg.userId}`,
          method: 'PUT',
          body: queryArg.userGrantsRequest,
        }),
        invalidatesTags: ['permission-controller'],
      }),
      createUserGrants: build.mutation<
        CreateUserGrantsApiResponse,
        CreateUserGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/grants/${queryArg.userId}`,
          method: 'POST',
          body: queryArg.userGrantsRequest,
        }),
        invalidatesTags: ['permission-controller'],
      }),
      updateUserGrantsStatus: build.mutation<
        UpdateUserGrantsStatusApiResponse,
        UpdateUserGrantsStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/grants/status`,
          method: 'PUT',
          body: queryArg.userGrantsStatusUpdateRequest,
        }),
        invalidatesTags: ['permission-controller'],
      }),
      updateUserGrantsFromProfile: build.mutation<
        UpdateUserGrantsFromProfileApiResponse,
        UpdateUserGrantsFromProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/grants/profile`,
          method: 'PUT',
          body: queryArg.profileGrantsRequest,
        }),
        invalidatesTags: ['permission-controller'],
      }),
      createUserGrantsFromProfile: build.mutation<
        CreateUserGrantsFromProfileApiResponse,
        CreateUserGrantsFromProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/grants/profile`,
          method: 'POST',
          body: queryArg.profileGrantsRequest,
        }),
        invalidatesTags: ['permission-controller'],
      }),
      denormalizeGrantsForRole: build.mutation<
        DenormalizeGrantsForRoleApiResponse,
        DenormalizeGrantsForRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/roles/${queryArg.roleId}/refresh`,
          method: 'POST',
        }),
        invalidatesTags: ['permission-controller'],
      }),
      denormalizeAllGrants: build.mutation<
        DenormalizeAllGrantsApiResponse,
        DenormalizeAllGrantsApiArg
      >({
        query: () => ({ url: `/2021-11-15/roles/refresh`, method: 'POST' }),
        invalidatesTags: ['permission-controller'],
      }),
      getMyPermissions: build.query<
        GetMyPermissionsApiResponse,
        GetMyPermissionsApiArg
      >({
        query: () => ({ url: `/2024-10-07/me` }),
        providesTags: ['permission-controller'],
      }),
      checkPermissions: build.query<
        CheckPermissionsApiResponse,
        CheckPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.profileId}/grantedState`,
          params: {
            scope: queryArg.scope,
            action: queryArg.action,
          },
        }),
        providesTags: ['permission-controller'],
      }),
      getRoles: build.query<GetRolesApiResponse, GetRolesApiArg>({
        query: () => ({ url: `/2021-11-15/roles` }),
        providesTags: ['permission-controller'],
      }),
      getUserGrants: build.query<GetUserGrantsApiResponse, GetUserGrantsApiArg>(
        {
          query: (queryArg) => ({ url: `/2021-11-01/${queryArg.userId}` }),
          providesTags: ['permission-controller'],
        }
      ),
      deleteUserGrants: build.mutation<
        DeleteUserGrantsApiResponse,
        DeleteUserGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-06/grants/${queryArg.userId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['permission-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as permissionsApi };
export type UpdateUserGrantsApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type UpdateUserGrantsApiArg = {
  userId: string;
  userGrantsRequest: UserGrantsRequest;
};
export type CreateUserGrantsApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type CreateUserGrantsApiArg = {
  userId: string;
  userGrantsRequest: UserGrantsRequest;
};
export type UpdateUserGrantsStatusApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type UpdateUserGrantsStatusApiArg = {
  userGrantsStatusUpdateRequest: UserGrantsStatusUpdateRequest;
};
export type UpdateUserGrantsFromProfileApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type UpdateUserGrantsFromProfileApiArg = {
  profileGrantsRequest: ProfileGrantsRequest;
};
export type CreateUserGrantsFromProfileApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type CreateUserGrantsFromProfileApiArg = {
  profileGrantsRequest: ProfileGrantsRequest;
};
export type DenormalizeGrantsForRoleApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DenormalizeGrantsForRoleApiArg = {
  /** Role ID */
  roleId: string;
};
export type DenormalizeAllGrantsApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DenormalizeAllGrantsApiArg = void;
export type GetMyPermissionsApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type GetMyPermissionsApiArg = void;
export type CheckPermissionsApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type CheckPermissionsApiArg = {
  /** userId of the user where grants will be read. */
  profileId: string;
  /** scope being asked. */
  scope: string;
  /** actions being asked. */
  action: string[];
};
export type GetRolesApiResponse =
  /** status 200 OK */ GmResponseCommonListRoleResponse;
export type GetRolesApiArg = void;
export type GetUserGrantsApiResponse =
  /** status 200 OK */ GmResponseCommonUserGrantsResponse;
export type GetUserGrantsApiArg = {
  userId: string;
};
export type DeleteUserGrantsApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type DeleteUserGrantsApiArg = {
  userId: string;
};
export type GrantResponse = {
  scope?: string;
  grants?: {
    [key: string]: boolean;
  };
};
export type UserGrantsResponse = {
  grantedPermissions?: GrantResponse[];
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonUserGrantsResponse = {
  result?: UserGrantsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GrantRequestJson = {
  /** Scope of the grant. */
  scope: string;
  /** Role ID of the grant. */
  roleId: string;
};
export type UserGrantsRequest = {
  /** List of grant requests. */
  grants: GrantRequestJson[];
};
export type UserGrantsStatusUpdateRequest = {
  /** Profile Id */
  id: string;
  /** Status */
  status: string;
  /** CDI Profile Id */
  cdiProfileId?: string;
};
export type ProfileGrantsRequest = {
  /** Profile ID. */
  id: string;
  /** Email address */
  email?: string;
  /** App ID */
  appId?: string;
  /** User role name */
  roleName?: string;
  /** User role name */
  permissions?: string[];
  /** Status of the grant. */
  status: string;
  /** Organization ID */
  organizationId?: string;
  /** Fleet ID */
  fleetId?: string;
};
export type GmResponseCommonVoid = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonBoolean = {
  result?: boolean;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RoleResponse = {
  roleId?: string;
  organizationId?: string;
  description?: string;
  roleName?: string;
  actions?: string[];
};
export type GmResponseCommonListRoleResponse = {
  result?: RoleResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useUpdateUserGrantsMutation,
  useCreateUserGrantsMutation,
  useUpdateUserGrantsStatusMutation,
  useUpdateUserGrantsFromProfileMutation,
  useCreateUserGrantsFromProfileMutation,
  useDenormalizeGrantsForRoleMutation,
  useDenormalizeAllGrantsMutation,
  useGetMyPermissionsQuery,
  useCheckPermissionsQuery,
  useGetRolesQuery,
  useGetUserGrantsQuery,
  useDeleteUserGrantsMutation,
} = injectedRtkApi;
